import React from 'react';
import { Star } from 'lucide-react';
import { ProductDetailRatingElementDataType } from '@/components/sections/builder/elements/body/product-detail/type';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';
import { IProduct } from '@/types/product';
import { useStoreSetting } from '@/app/(store)/s/[domain]/store-context';
import { DEFAULT_THEME_COLOR_SCHEME } from '@/components/sections/builder/theme/color';

const defaultData: ProductDetailRatingElementDataType = {
  name: 'Product Rating',
  starColor: '#F05123',
};

export const ElementContent = ({ element, preview }: ElementProps) => {
  const { storeSetting } = useStoreSetting();
  const parentData = (element.parentData || {}) as IProduct;
  const avgRating = parentData?.rating_average ?? 0;
  const reviewTotal = parentData?.total_reviews ?? 0;

  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const themeContent = preview ? builder.theme : element.theme;

  const starColor = themeContent?.productRating?.starColor || DEFAULT_THEME_COLOR_SCHEME.text;

  const reviewSetting = storeSetting?.product_settings?.review_product;

  if (!reviewSetting && !preview) return null;

  return (
    <div className='flex items-center space-x-2'>
      <div className='flex items-center space-x-1'>
        {Array.from({ length: 5 }).map((_, i) => {
          const starNumber = i + 1;
          let fillPercent = 0;

          if (avgRating >= starNumber) {
            fillPercent = 100;
          } else if (avgRating > i && avgRating < starNumber) {
            fillPercent = (avgRating - i) * 100;
          }

          return (
            <div key={i} className='relative h-5 w-5'>
              <Star
                className='h-5 w-5'
                style={{
                  stroke: starColor,
                  fill: 'transparent',
                }}
              />
              {fillPercent > 0 && (
                <Star
                  className='absolute left-0 top-0 h-5 w-5'
                  style={{
                    stroke: starColor,
                    fill: starColor,
                    clipPath: `inset(0 ${100 - fillPercent}% 0 0)`,
                  }}
                />
              )}
            </div>
          );
        })}
      </div>

      <span className='text-lg'>{`${reviewTotal} Reviews`}</span>
    </div>
  );
};

export const ElementPreviewIcon = Star;

const ProductRating = {
  type: 'rating',
  group: 'product_detail',
  defaultData,
  Element: ElementContent,
  PreviewIcon: ElementPreviewIcon,
  Icon: ElementPreviewIcon,
  childs: [],
  maxEntries: 1,
};

export default ProductRating;
